export const initBlockData = {
  title: "All Destinations",
};

export const initEmptyBlockData = {
  title: "",
};
